import addToBagModal from './addToBagModal';
import angularvideo from './angularvideo';
import anthroAccordion from './anthroAccordion';
import anthroModal from './anthroModal';
import barcodeGenerator from './barcodeGenerator';
import centerVertically from './centerVertically';
import childCatColumns from './childCatColumns';
import closePanel from './closePanel';
import closePopup from './closePopup';
import confirmationButton from './confirmationButton';
import domReady from './domReady';
import dropShadow from './dropShadow';
import emailFocus from './emailFocus';
import footerSlot from './footerSlot';
import formatChildNav from './formatChildNav';
import halfTakeover from './halfTakeover';
import hideCurrencies from './hideCurrencies';
import includeJsp from './includeJsp';
import mobileSignOut from './mobileSignOut';
import mouseenter from './mouseenter';
import mouseleave from './mouseleave';
import mouseover from './mouseover';
import orientationChange from './orientationChange';
import pagination from './pagination';
import t from './t';
import togglePanel from './togglePanel';
import toolTip from './toolTip';
import topNav from './topNav';
import toTop from './toTop';
import utagLink from './utagLink';

export const legacyDirectives = angular.module('legacy.directives', [])
    .directive('addToBagModal', addToBagModal)
    .directive('angularvideo', angularvideo)
    .directive('anthroAccordion', anthroAccordion)
    .directive('anthroModal', anthroModal)
    .directive('barcodeGenerator', barcodeGenerator)
    .directive('centerVertically', centerVertically)
    .directive('childCatColumns', childCatColumns)
    .directive('closePanel', closePanel)
    .directive('closePopup', closePopup)
    .directive('confirmationButton', confirmationButton)
    .directive('domReady', domReady)
    .directive('dropShadow', dropShadow)
    .directive('emailFocus', emailFocus)
    .directive('footerSlot', footerSlot)
    .directive('formatChildNav', formatChildNav)
    .directive('halfTakeover', halfTakeover)
    .directive('hideCurrencies', hideCurrencies)
    .directive('includeJsp', includeJsp)
    .directive('mobileSignOut', mobileSignOut)
    .directive('mouseenter', mouseenter)
    .directive('mouseleave', mouseleave)
    .directive('mouseover', mouseover)
    .directive('orientationChange', orientationChange)
    .directive('pagination', pagination)
    .directive('t', t)
    .directive('togglePanel', togglePanel)
    .directive('toolTip', toolTip)
    .directive('topNav', topNav)
    .directive('toTop', toTop)
    .directive('utagLink', utagLink);

export default legacyDirectives;
